/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CustomRouterState, NavigationBreadcrumb, RouteStaticParam } from '@elio/emanager-front/shared/tools/router';
import { removeDuplicateForKeyInArrayOfObject } from '@elio/shared/utils';
import { RouterStateSerializer } from '@ngrx/router-store';

export class CustomRouterStateSerializer implements RouterStateSerializer<CustomRouterState> {
  serialize(routerState: RouterStateSnapshot): CustomRouterState {
    let route = routerState.root;

    let routeParams: Record<RouteStaticParam, unknown> = {} as any;
    while (route.firstChild) {
      route = route.firstChild;
      routeParams = { ...routeParams, ...route.params };
    }

    return {
      routeParams,
      queryParams: route.queryParams,
      url: routerState.url,
      navigationBreadcrumbs: removeDuplicateForKeyInArrayOfObject(
        this.getNavigationBreadcrumbs(routerState.root),
        'label'
      ),
    };
  }

  private getNavigationBreadcrumbs(route: ActivatedRouteSnapshot | null): NavigationBreadcrumb[] {
    if (!route) {
      return [];
    }
    const { breadcrumb } = route.data;
    const nextChild = route.firstChild;

    return breadcrumb
      ? [{ ...breadcrumb }, ...this.getNavigationBreadcrumbs(nextChild)]
      : [...this.getNavigationBreadcrumbs(nextChild)];
  }
}
